module.exports = __webpack_public_path__ + "static/mt-logo-white.8c6d4f24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mt-logo-white.svg
// module id = 1486
// module chunks = 168707334958949